
export const userTypesRBK = ['Operator', 'Admin', 'Expertise', 'ExpertisePayment', 'Manager'];

export const userTypes = ['Operator', 'Admin', 'Expertise', 'ExpertisePayment', 'Client', 'InsuranceCo', 'Accounting', 'Manager'];